import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-models',
    templateUrl: './models.component.html',
    styleUrls: ['./models.component.css']
})
export class ModelsComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
